export default {
  SET_CONTACT_DATA(state, contactData) {
    state.contacts = contactData;
  },
  SET_CONTACT_RECORDS(state, totalContacts) {
    state.totalContacts = totalContacts;
  },
  SET_CURRENT_PAGE(state, data) {
    state.contacts.currentPage = data;
  },
};
